module.exports = __webpack_public_path__ + "static/media/jq.a284844f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/jq.png
// module id = 661
// module chunks = 0 1